import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { CancelDialogComponent } from 'src/app/shared/cancel-dialog/cancel-dialog.component';
import { GroupService } from '../services/group.service';
import { Group } from 'backend/interfaces/group.interface';

@Component({
  selector: 'app-view-group',
  templateUrl: './view-group.component.html',
  styleUrls: ['./view-group.component.scss']
})
export class ViewGroupComponent implements OnInit {
  loading = false;
  groupId: string;
  faTimes  = faTimes;
  group: Group;
  constructor(private router: Router, private ar: ActivatedRoute, public dialog: MatDialog, private groupService: GroupService) { }

  async ngOnInit(): Promise<void> {
    this.loading = true
    this.groupId = this.ar.snapshot.params['id'];
    this.groupService.getGroupById(this.groupId).then(res => {
      this.group = res;
      this.loading = false;
    });
  }
  cancel(){
    this.groupId = null;
    this.router.navigate(['admin', 'categories']);
  }

  openCancelDialog(): void {
    const dialogRef = this.dialog.open(CancelDialogComponent, {
      data: {title: 'Close Category', question: 'Have you saved your changes?'}
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.cancel();
      } else {
        this.dialog.closeAll();
      }
    });
  }
}
